import ash from "./images/ash-close.jpg";
import bulewa from "./images/bulewa-close.jpg";
import chintu from "./images/chintu-close.jpg";
import deb from "./images/deb-close.jpg";
import liz from "./images/liz-close.jpg";
import marlene from "./images/marlene-close.jpg";
import sharon from "./images/sharon-close.jpg";
import thandiwe from "./images/thandiwe-close.jpg";
import yewande from "./images/yewande-close.jpg";
import zen from "./images/zen-close.jpg";

export const content = [
   {
    name: "Yewande Sadiku",
    first : "Yewande",
    last : "Sadiku",
    title: "Head: Investment Banking, International, Corporate and Investment Banking",
    image: yewande,
    quote: "Experience and skill always come in disguise, not on a platter of gold with a ribbon around it. If you want skills and experience, you must be ready to put in the work.",
    
},
{
    name: "SHARON BRIGHTON",
    first : "Sharon",
    last : "Brighton",
    title: "Head: Legal, Investment Banking, Africa Regions, Corporate and Investment Banking",
    image: sharon,
    quote: "Every woman should be the network, the mentor, or the sponsor for other women. We cannot rely solely on men."
},
{
    name: "ashleigh pledger",
    first : "Ashleigh",
    last : "Pledger",
    title: "Chief Operating Officer: Transaction Banking, Corporate and Investment Banking",
    image: ash,
    quote: "We need the voices of women leaders at every level of society to drive change and, in the process, inspire those around them and generations to come to pursue their ambitions."
},
{
    name: "Debora Bekker",
    first : "Debora",
    last : "Bekker",
    title: "Executive: Equity Risk South Africa, Corporate and Investment Banking",
    image: deb,
    quote: "Leadership is taught, not just innate. Incrementally increasing exposure to appropriate levels of responsibility is the key to nurturing talent."
},
{
    name: "Marlene Pillay",
    first : "Marlene",
    last : "Pillay",
    title: "Head: Real Estate Finance Debt Solutions Management, Corporate and Investment Banking",
    image: marlene,
    quote: "Aim to be exceptional at every task and demonstrate your worth through actions. Always act with integrity, own your failures, find the silver lining, never miss deadlines, and  make sure you look good doing it."
},
{
    name: "Elizabeth Muchemi",
    first : "Elizabeth",
    last : "Muchemi",
    title: "Head: Global Markets International, Corporate and Investment Banking",
    image: liz,
    quote: "You are enough. In fact, you are more than enough, so just take that shot because you are incredible."
},
{
    name:"Zen Dlamini",
    first : "Zen",
    last : "Dlamini",
    title: "Executive Head: Sovereign & Public Sector, Client Coverage, Corporate and Investment Banking",
    image: zen,
    quote: "I've stood on men’s shoulders to get to where I am, but I want women to stand on my shoulders so that I lift as I rise."
},
{
    name: "Bulelwa Tetyana Madonsela",
    first : "Bulelwa",
    last : "Madonsela",
    title: "Head: Strategy Enablement - Global Markets, Corporate and Investment Banking",
    image: bulewa,
    quote: "As a leader, I’m not afraid to show up as one who doesn’t know everything. If I purport to know everything it disempowers the people around me."
},
{
    name: "Chintu Ling'Omba",
    first : "Chintu",
    last : "Ling'Omba",
    title: "Head: Client Coverage Africa Regions, Corporate and Investment Banking",
    image: chintu,
    quote: "When you’re in a decision-making position, don’t be afraid to actively prioritise other women in your mentoring, coaching and sponsoring activities."
},
{
    name: "Thandiwe Legwaila",
    first : "Thandiwe",
    last : "Legwaila",
    title: "Head: Transaction Banking, Corporate. and Investment Banking",
    image: thandiwe,
    quote: "I'm unapologetic about our focus on accelerating the promotion of women into leadership positions and our investment towards their learning and development."
}
]




    

